module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "slider-open"
  }, [_c('div', {
    staticClass: "slider-open-top"
  }, [_c('div', {
    staticClass: "slider-open-left"
  }, [_vm._v("切换推荐类目")]), _vm._v(" "), _c('div', {
    staticClass: "slider-right",
    on: {
      "click": _vm.showAllPart
    }
  }, [_c('div', {
    staticClass: "slider-triangle-up"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "slider-open-buttom"
  }, [_c('ul', {
    staticClass: "slider-open-buttom-ul"
  }, _vm._l((_vm.sliderLists), function(sliderList, index) {
    return _c('li', {
      key: index,
      staticClass: "open-item",
      class: {
        'open-item-active': index == _vm.currentPart
      },
      on: {
        "click": function($event) {
          return _vm.changePart(index)
        }
      }
    }, [_c('a', {
      staticClass: "anchor",
      attrs: {
        "href": '#anchor-' + index
      }
    }, [_vm._v(_vm._s(sliderList.title))])])
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-76cdf60c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/slider/sliderOn.vue
// module id = 121
// module chunks = 1